// "26 Oct 2026"
export const fmtDate = (value) => {
  if (!value) return "";
  const d = new Date(String(value).replace(" ", "T"));
  return isNaN(d) ? "" : d.toLocaleDateString("en-PH", { day: "2-digit", month: "short", year: "numeric" });
};

// Cancelled at this bank, or the whole application cancelled (lost): date
// (+ reason), the remark, and what's now read-only. `details` is a
// cancel_details object.
export default function CancelNote({ details, wholeApp }) {
  const c = details || {};
  const on = c.cancelled_at ? " on " + fmtDate(c.cancelled_at) : "";
  return (
    <div className="bank-cancel-note">
      <div className="bank-cancel-note__title">
        {wholeApp ? "Application cancelled" + on + (c.reason_name ? " · " + c.reason_name : "") : "Cancelled at this bank" + on}
      </div>
      {c.remark && <div className="bank-cancel-note__remark">{c.remark}</div>}
      <div className="bank-cancel-note__foot">
        {wholeApp ? "Everything on this application is read-only." : "Steps for this bank are read-only. Other banks are not affected."}
      </div>
    </div>
  );
}
